module.exports = __webpack_public_path__ + "static/media/snoopythunder02.d9b38551.gif";